define([
	"canvas/widgets/interfaces/model/enumerations/PlaceholderTextFormat",
	"./_PlaceholderTextFormat",
	"./PluginFactory"
], function({PlaceholderTextFormat}, _PlaceholderTextFormat, PluginFactory) {

	return PluginFactory.declare(_PlaceholderTextFormat, {
		"class": "csi-button-toggle csi-toggle-group-last",
		enumValue: PlaceholderTextFormat.VALUE,
		label: "Values",
		pluginName: "PlaceholderTextValue",
		showLabel: true,
		title: "CanvasValues",

		/**
		 * @override
		 * Disable plugin if this is rich-text placeholder
		 */
		 enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const {editor} = this;
			this.set("checked", this.enumValue === editor.canvasApp.pageHelper.getPlaceholderTextFormat());
			return !editor.isRichTextPlaceholderSelected(shapes);
		},
	});
});
